export const CONTEXT_AGENT_SPRITE_SIZE = 48;
/** @deprecated Use CONTEXT_AGENT_SPRITE_SIZE */
export const WIDGET_LAUNCHER_SIZE = CONTEXT_AGENT_SPRITE_SIZE;
export const WIDGET_VIEWPORT_MARGIN = 12;
export const WIDGET_DEFAULT_INSET = 24;
export const WIDGET_PANEL_GAP = 12;
export const WIDGET_DRAG_THRESHOLD = 5;
